/* unplugin-vue-components disabled */import script from "./ctaBanner.vue?vue&type=script&lang=js"
export * from "./ctaBanner.vue?vue&type=script&lang=js"

import "./ctaBanner.vue?vue&type=style&index=0&id=76af792d&lang=scss"

const __exports__ = script;

export default __exports__